const state = {
  activeMenu: null
}

const getters = {
  isSearchActive: (state) => {
    return state.activeMenu === "search"
  }
}

const mutations = {
  openMenu: (state, payload) => {
    state.activeMenu = payload
  },
  closeMenu: (state) => {
    state.activeMenu = null
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
